import React from 'react'
import { parseQuery } from '../../../util'
import Heading from '../../common/heading'
import Input from '../../common/input'
import Button from '../../common/button'
import { joinTable } from '../../../routes'
import Paths, { openRoute } from '../../../router'
import { getStorageValue, setStorageValue, StorageFieldDefaults, StorageFields } from '../../../storage/browserStorage'

class JoinTable extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            name: getStorageValue(StorageFields.PLAYER_NAME),
            isJoining: false
        }
    }

    handleJoin()
    {
        const tableCode = this.props.match.params.code
        setStorageValue(StorageFields.PLAYER_NAME, this.state.name)
        
        this.setState({ isJoining: true }, () => {
            joinTable(
                tableCode,
                this.state.name,
                resp => {
                    const key = resp.playerKey
                    openRoute(this.props.history, Paths.Table.TABLE, tableCode, key)
                },
                err => {
                    getDialog().show({
                        content: Messages("join.error." + err.tableStatus),
                        buttons: [{ text: Messages("app.go-to-start"), onClick: () => openRoute(this.props.history, Paths._PATH) }]
                    })
                }
            )
        })
    }

    render()
    {
        return (
            <div>
                <Heading showBackButton>
                    { Messages("join.heading") }
                </Heading>
                <div>{ Messages("join.name.description") }</div>
                <Input
                    placeholder={ Messages("join.name.placeholder") }
                    value={ this.state.name }
                    onChange={ v => this.setState({ name: (v || "").substr(0, 50) }) }
                    style={{ margin: "15px 0px" }}
                />
                <Button
                    disabled={ this.state.isJoining || this.state.joinError || !this.state.name.length }
                    text={ Messages("join.action") }
                    onClick={ this.handleJoin.bind(this) }
                />
            </div>
        )
    }

}

export default JoinTable
export { JoinTable }